module.exports = __webpack_public_path__ + "img/w矩形 81@3x.8a73cd09.png";